import dayjs from "dayjs";
import "dayjs/locale/cy";
import "dayjs/locale/da";
import "dayjs/locale/en-gb";
import "dayjs/locale/fr";
import "dayjs/locale/es";

export function formatDateTime(
  dateString: string | null | undefined,
  locale: string,
): string | null {
  if (!dateString) return null;

  const date = dayjs(dateString);
  if (!date.isValid()) return dateString;

  return date.locale(locale?.trim() || "en").format("D MMMM YYYY, HH:mm");
}

export function formatDate(
  dateString: string | null | undefined,
  locale: string,
): string | null {
  if (!dateString) return null;

  const date = dayjs(dateString);
  if (!date.isValid()) return dateString;

  return date.locale(locale?.trim() || "en").format("D MMMM YYYY");
}
